import { Data } from "../../Models/Common/Common";
import { Get, Post, PostBlob } from "../../Utils/AxiosHelper/AxiosHelper";
const api = {
  getCarInfoFromChassisNumber: "salesorders/getCarInfoFromChassisNumber",
  getSalesOrdersWithFilter: "salesorders/getSalesOrdersWithFilter",
  getSalesOrdersWithFilterForClient:
    "salesorders/getSalesOrdersWithFilterForClient",
  getAccountFavouriteSalesOrdersWithFilter:
    "salesorders/getAccountFavouriteSalesOrdersWithFilter",
  getTransactionOrdersWithFilterForClient:
    "salesorders/getTransactionOrdersWithFilterForClient",
  insertSalesOrder: "salesorders/insertSalesOrder",
  updateSalesOrder: "salesorders/updateSalesOrder",
  estimationCarPrice: "salesorders/estimationCarPrice",
  updateSalesOrderWithDocuments: "salesorders/updateSalesOrderWithDocuments",
  updateSalesOrderWithExpert: "salesorders/updateSalesOrderWithExpert",
  updateSalesOrderWithComment: "salesorders/updateSalesOrderWithComment",
  getOrderDocuments: "salesorders/getOrderDocuments",
  changeStateSalesOrder: "salesorders/changeStateSalesOrder",
  confirmSalesOrder: "salesorders/confirmSalesOrder",
  getSalesOrderInfo: "salesorders/getSalesOrderInfo",
  getSalesOrderInfoWithDetails: "salesorders/getSalesOrderInfoWithDetails",
  getActiveTariffs: "salesorders/getActiveTariffs",
  getOrderAmount: "salesorders/getOrderAmount",
  insertOfferPrice: "salesorders/insertOfferPrice",
  getAccountSalesOrders: "salesorders/getAccountSalesOrders",
  changeFavouritSalesOrder: "salesorders/changeFavouritSalesOrder",
  getSalesOrdersForPurchaseRequest:
    "salesorders/getSalesOrdersForPurchaseRequest",
  rateOrder: "salesorders/assignRaitToOrder",
  cancelOrder: "salesorders/cancelOrder",
  getCancelReasons: "salesorders/getSalesOrderCancelReasons",
  paySalesOrderOnline: "credits/paySalesOrderOnline",
  paySalesOrder: "credits/paySalesOrder",
  getRatingsForSalesOrder: "ratings/getRatingsForSales",
  getImageById: "documents/getImageById",
  expertOrderPrintFromSales: "reports/expertOrderPrintFromSales",
  insertAgencySalesOrder: "salesorders/insertAgencySalesOrder",
  trackingSalesOrder: "salesorders/trackingSalesOrder",
  getAvailableAccountManagers: "salesorders/getAvailableAccountManagers",
  hasActiveOrderWithChassisNumber:
    "salesorders/hasActiveOrderWithChassisNumber",
  getStock: "salesorders/getStock",
  draftContractPrint: "reports/draftContractPrint",
};
const SalesOrderServices = {
  GetCarInfoFromChassisNumber: (command: any, then: Data<any>) => {
    Post(api.getCarInfoFromChassisNumber, command, then);
  },
  GetAccountSalesOrders: (command: any, then: Data<any>) => {
    Post(api.getAccountSalesOrders, command, then);
  },
  GetSalesOrdersWithFilter: (command: any, then: Data<any>) => {
    Post(api.getSalesOrdersWithFilter, command, then);
  },
  GetSalesOrdersWithFilterForClient: (command: any, then: Data<any>) => {
    Post(api.getSalesOrdersWithFilterForClient, command, then);
  },
  GetAccountFavouriteSalesOrdersWithFilter: (command: any, then: Data<any>) => {
    Post(api.getAccountFavouriteSalesOrdersWithFilter, command, then);
  },
  GetTrasnsactionOrdersWithFilterForClient: (command: any, then: Data<any>) => {
    Post(api.getTransactionOrdersWithFilterForClient, command, then);
  },
  GetSalesOrderInfo: (command: any, then: Data<any>) => {
    Post(api.getSalesOrderInfo, command, then);
  },
  GetSalesOrderInfoWithDetails: (command: any, then: Data<any>) => {
    Post(api.getSalesOrderInfoWithDetails, command, then);
  },
  InsertSalesOrder: (command: any, then: Data<any>) => {
    Post(api.insertSalesOrder, command, then);
  },
  InsertAgencySalesOrder: (command: any, then: Data<any>) => {
    Post(api.insertAgencySalesOrder, command, then);
  },
  UpdateSalesOrder: (command: any, then: Data<any>) => {
    Post(api.updateSalesOrder, command, then);
  },
  EstimationCarPrice: (command: any, then: Data<any>) => {
    Post(api.estimationCarPrice, command, then);
  },
  UpdateSalesOrderWithDocuments: (command: any, then: Data<any>) => {
    Post(api.updateSalesOrderWithDocuments, command, then);
  },
  UpdateSalesOrderWithExpert: (command: any, then: Data<any>) => {
    Post(api.updateSalesOrderWithExpert, command, then);
  },
  UpdateSalesOrderWithComment: (command: any, then: Data<any>) => {
    Post(api.updateSalesOrderWithComment, command, then);
  },
  GetOrderDocuments: (command: any, then: Data<any>) => {
    Post(api.getOrderDocuments, command, then);
  },
  ConfirmSalesOrder: (command: any, then: Data<any>) => {
    Post(api.confirmSalesOrder, command, then);
  },
  ChangeState: (command: any, then: Data<any>) => {
    Post(api.changeStateSalesOrder, command, then);
  },
  GetOrderAmount: (command: any, then: Data<any>) => {
    Post(api.getOrderAmount, command, then);
  },
  InsertOfferPrice: (command: any, then: Data<any>) => {
    Post(api.insertOfferPrice, command, then);
  },
  ChangeFavouritSalesOrder: (command: any, then: Data<any>) => {
    Post(api.changeFavouritSalesOrder, command, then);
  },
  GetSalesOrdersForPurchaseRequest: (command: any, then: Data<any>) => {
    Post(api.getSalesOrdersForPurchaseRequest, command, then);
  },
  RateOrder: (command: any, then: Data<any>) => {
    Post(api.rateOrder, command, then);
  },
  GetRatingsForSalesOrder: (command: any, then: Data<any>) => {
    Post(api.getRatingsForSalesOrder, command, then);
  },
  GetImageById: (command: any, then: Data<any>) => {
    Get(api.getImageById, command, then);
  },
  GetCancelReasons: (command: any, then: Data<any>) => {
    Post(api.getCancelReasons, command, then);
  },
  CancelOrder: (command: any, then: Data<any>) => {
    Post(api.cancelOrder, command, then);
  },
  ExpertOrderPrintFromSales: (command: any, name: string, then: Data<any>) => {
    PostBlob(api.expertOrderPrintFromSales, command, then, name);
  },
  PaySalesOrderOnline: (command: any, then: Data<any>) => {
    Post(api.paySalesOrderOnline, command, then);
  },
  PaySalesOrder: (command: any, then: Data<any>) => {
    Post(api.paySalesOrder, command, then);
  },
  TrackingSalesOrder: (command: any, then: Data<any>) => {
    Post(api.trackingSalesOrder, command, then);
  },
  GetAvailableAccountManagers: (command: any, then: Data<any>) => {
    Post(api.getAvailableAccountManagers, command, then);
  },
  HasActiveOrderWithChassisNumber: (command: any, then: Data<any>) => {
    Post(api.hasActiveOrderWithChassisNumber, command, then);
  },
  GetStock: (command: any, then: Data<any>) => {
    Post(api.getStock, command, then);
  },
  DraftContractPrint: (command: any, name: string, then: Data<any>) => {
    PostBlob(api.draftContractPrint, command, then, name);
  },
};
export default SalesOrderServices;
